/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef, memo } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { emojiButton, hidden } from './styles';
import Emoji from './Emoji';
export var tonePreviewTestId = 'tone-preview';
export var TonePreviewButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var emoji = props.emoji,
    selectOnHover = props.selectOnHover,
    ariaLabelText = props.ariaLabelText,
    ariaExpanded = props.ariaExpanded,
    onSelected = props.onSelected,
    _props$isVisible = props.isVisible,
    isVisible = _props$isVisible === void 0 ? true : _props$isVisible;
  return jsx("button", {
    ref: ref
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ,
    css: [emojiButton, !isVisible && hidden],
    onClick: onSelected,
    "aria-label": ariaLabelText,
    "aria-expanded": ariaExpanded,
    "aria-controls": "emoji-picker-tone-selector"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: {
      overflow: 'hidden'
    },
    "data-testid": tonePreviewTestId,
    type: "button"
  }, jsx(Emoji, {
    emoji: emoji,
    selectOnHover: selectOnHover,
    shouldBeInteractive: false,
    "aria-hidden": true
  }));
});
export default /*#__PURE__*/memo(TonePreviewButton);